import React, {useEffect, useState} from 'react'
import Button from '@components/Button'
import Layout from '@page-components/Layout'
import useInitialData from '@page-components/Layout/useInitialData'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function SendingToKitchen(props) {
  const {order, cancelSending, sendToKitchen} = props
  const initialData = useInitialData()
  const [counter, setCounter] = useState(10)
  const {t} = useTranslation()
  const i18nWebsite = 'website:order.cart'

  useEffect(() => {
    const timeout = setTimeout(sendToKitchen, 10000)
    const counterInterval = setInterval(() => {
      setCounter(value => value - 1)
    }, 1000)
    return () => {
      clearTimeout(timeout)
      clearInterval(counterInterval)
    }
  }, [])

  return (
    <Layout initialData={initialData} theme="clean">
      <div className={styles.container}>
        <h2 className={styles.productsToKitchenText}>
          {t(`${i18nWebsite}.sendingProductsToKitchen`)}
        </h2>

        <div className={styles.items}>
          <ul>
            {order.items.map(item => {
              return (
                <li key={item._id}>
                  <div className={styles.quantity}>{item.amount}x</div>
                  <div className={styles.name}>
                    <div className={styles.principal}>{item.product.name}</div>
                    <div className={styles.modifiers}>{item.description}</div>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
        <div className={styles.loaderContainer}>
          <div className="initialLoadingItem" />
        </div>
        <div className={styles.cta}>
          <Button onClick={cancelSending} primary disabled={counter < 0}>
            {t(`${i18nWebsite}.undo`)}{' '}
            {counter >= 0 ? <div className={styles.counter}>{counter}</div> : null}
          </Button>
        </div>
      </div>
    </Layout>
  )
}
